<script lang="ts">
import type { Snippet } from 'svelte'
import { fade } from 'svelte/transition'

type Props = {
	children?: Snippet
}

let { children }: Props = $props()
</script>

<div transition:fade={{ duration: 100 }} class="absolute bottom-[-8px] right-[16px] bg-white px-1">
	{@render children?.()}
</div>
